import usePaywallType from './paywallTypeAtom';

export * from './paywallTypeAtom';

export default usePaywallType;
